// Shared sliding-dot-indicator sizing, used by ThumbnailCarousel and
// BookCoverProject — both scroll-snap carousels with their own different
// logic for figuring out *which* two dots are the current straddle pair
// (ThumbnailCarousel: simple scrollLeft/offsetWidth division, one item per
// "page"; BookCoverProject: closest-snap-point search over unevenly-sized
// coverflow items), but once you have `fromIdx`/`toIdx`/`dotT` (0-1 progress
// between them), the actual dot width/opacity/color interpolation is
// identical — this is that shared final step.
export const DOT_ACTIVE_WIDTH = 24;
export const DOT_INACTIVE_WIDTH = 7;

export function updateCarouselDots(dotRefs, fromIdx, toIdx, dotT) {
  dotRefs.current.forEach((dot, i) => {
    if (!dot) return;
    if (i === fromIdx) {
      dot.style.width = `${DOT_ACTIVE_WIDTH - (DOT_ACTIVE_WIDTH - DOT_INACTIVE_WIDTH) * dotT}px`;
      dot.style.opacity = String(1 - 0.5 * dotT);
      dot.style.backgroundColor = 'var(--text-primary)';
    } else if (i === toIdx && dotT > 0) {
      dot.style.width = `${DOT_INACTIVE_WIDTH + (DOT_ACTIVE_WIDTH - DOT_INACTIVE_WIDTH) * dotT}px`;
      dot.style.opacity = String(0.5 + 0.5 * dotT);
      dot.style.backgroundColor = 'var(--text-primary)';
    } else {
      dot.style.width = `${DOT_INACTIVE_WIDTH}px`;
      dot.style.opacity = '0.5';
      dot.style.backgroundColor = '';
    }
  });
}
